import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as InsuranceActions from '../_actions/insurance';
import { Insurance } from '../_models/insurance';

export interface InsuranceState extends EntityState<Insurance> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Insurance> = createEntityAdapter<Insurance>();

const initialState: InsuranceState = adapter.getInitialState({
  loading: false,
  error: null,
});

const insuranceReducer = createReducer(
  initialState,

  on(InsuranceActions.loadInsurances, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(InsuranceActions.loadInsurancesSuccess, (state, { insurances }) =>
    adapter.setAll(insurances, { ...state, loading: false })
  ),

  on(InsuranceActions.loadInsurancesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(InsuranceActions.addInsuranceSuccess, (state, { insurance }) =>
    adapter.addOne(insurance, state)
  ),

  on(InsuranceActions.updateInsuranceSuccess, (state, { insurance }) =>
    adapter.upsertOne(insurance, state)
  ),

  on(InsuranceActions.deleteInsuranceSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    InsuranceActions.addInsuranceFailure,
    InsuranceActions.updateInsuranceFailure,
    InsuranceActions.deleteInsuranceFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: InsuranceState | undefined, action: Action) {
  return insuranceReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
